import { useContext } from 'react'
import { createCtx, InitializableProviderProps } from '../../../context/_createCtx'
import { ContactFormContextValues } from '../Form/_props'

export const defaultContactFormContextValues: ContactFormContextValues = {
    mode: 'CREATION',
    isDisabled: false,
    contactId: undefined,
}

const [ctx, provider] = createCtx(defaultContactFormContextValues)

export const ContactFormContextProvider = ({
    children,
    initialValues,
}: InitializableProviderProps<ContactFormContextValues>) => provider({ children, initialValues })

export const useContactFormContext = () => useContext(ctx)
